const Style = (theme) => ({
  root: {
    borderRadius: '100px',
    boxShadow: 'none',
    height: '44px',
    background: '#F6F6F8',
    display: 'flex',
    position: 'relative',
  },
  input: {
    flex: 1,
    borderLeft: '1px solid #DFDFDF',
    height: 'inherit',
    color: '#545b7d',
    fontSize: '14px',
    fontWeight: '600',
    paddingLeft: '15px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  root__dropdown__main: {
    maxHeight: '19rem',
    minHeight: '3rem',
    overflow: 'auto',
    width: '58%',
    position: 'absolute',
    zIndex: '999',
    top: '3.5rem',
    right: '12%',
    boxShadow: '0px 5px 16px rgba(0, 0, 0, 0.08)',
    padding: '0 1rem',
    borderRadius: '15px',
    background: '#fff',
  },
  dropdown__menu__text__heading: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000',
    padding: '.3rem 0',
  },
  dropdown__menu__text: {
    fontWeight: '500',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#6D7D8B',
    padding: '.4rem 0 .3rem',
  },
  list__item: {
    borderBottom: '0.25px solid #D4DCE8',
    padding: '0.5rem 0',
    cursor: 'poiter',
    '&:last-child': {
      borderBottom: '0',
    },
  },
});
export default Style;
